<template>
   <div>
      <big-title>Perfil <span>Fiscal</span>. </big-title>
      <vx-card title="Mantén actualizada tu información." class="mb-6">
         <div class="vx-col xxl:w-3/4 w-full">
            <p>
               Debido a la Reforma Fiscal 2022, Para la emisión de comprobante <b>(CFDI)</b> es importante que
               registres tus datos fiscales tal y como aparecen en tu <b>Constancia de Situación Fiscal</b>
               la cual puedes consultar en el
               <a class="inline-link-primary bold" target="_blank" rel="noopener" :href="$sanitizeUrl(satUrl)">SAT</a>.
            </p>
         </div>
      </vx-card>
      <vx-card>
         <div class="vx-row">
            <div :class="colClass">
               <vs-input @input="(val) => (rfc = rfc.toUpperCase())" class="w-full" label="RFC *" name="rfc"
                  v-validate="requiredRules" v-model.lazy="rfc" :danger="hasError('rfc')" :danger-text="errorText('rfc')"
                  :success="isSuccess('rfc')" icon-pack="feather" :placeholder="requiredPlaceholder" />
               <a class="inline-link-primary" target="_blank" rel="noopener" :href="$sanitizeUrl(rfcUrl)">Consultar mi
                  RFC</a>
            </div>
            <div :class="colClass">
               <vs-input @input="(val) => (taxName = taxName.toUpperCase())" class="w-full" label="Nombre fiscal *"
                  name="taxName" v-validate="requiredRules" v-model.lazy="taxName" :danger="hasError('taxName')"
                  :danger-text="errorText('taxName')" :success="isSuccess('taxName')" icon-pack="feather"
                  :placeholder="requiredPlaceholder" />
            </div>
         </div>
         <div class="vx-row">
            <div :class="colClass">
               <vs-input class="w-full" label="Código postal fiscal *" name="taxZipCode" v-validate="'required|numeric'"
                  v-model.lazy="taxZipCode" :danger="hasError('taxZipCode')" :danger-text="errorText('taxZipCode')"
                  :success="isSuccess('taxZipCode')" icon-pack="feather" :placeholder="requiredPlaceholder" />
            </div>
            <div :class="colClass">
               <vs-select placeholder="Selecciona una opción" class="w-full" label="Régimen Fiscal *"
                  v-model.lazy="taxRegimeId" name="taxRegimeId" v-validate="requiredRules" @input="setCfdis()"
                  :danger="hasError('taxRegimeId')" :danger-text="errorText('taxRegimeId')"
                  :success="isSuccess('taxRegimeId')">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                     v-for="(item, index) in collections.taxRegimesFiltered" />
               </vs-select>
            </div>
         </div>
         <div class="vx-row">
            <div :class="colClass">
               <vs-select placeholder="Selecciona una opción" class="w-full" label="Uso de CFDI *" v-model.lazy="cfdiId"
                  name="cfdiId" v-validate="requiredRules" :danger="hasError('cfdiId')" :danger-text="errorText('cfdiId')"
                  :success="isSuccess('cfdiId')">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                     v-for="(item, index) in collections.cfdisFiltered" />
               </vs-select>
            </div>
         </div>
         <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle" class="mb-5" color="danger">
            <span class="font-regular">{{ errorMssg }}</span>
         </vs-alert>
         <div class="vx-row">
            <div class="vx-col w-full">
               <p class="bold" v-if="fiscalValidationTimestamp">
                  Los datos ya fueron verificados el: {{ explicitDateFormat(fiscalValidationTimestamp) }}<br>
                  Si deseas actualizarlos nuevamente contactanos por el chat.
               </p>
               <vs-button v-else-if="showButton" @click="saveDataForm">Guardar cambios</vs-button>
            </div>
         </div>
      </vx-card>
      <vx-card class="mt-6">
         <div class="vx-col xxl:w-3/4 w-full">
            <li class="bold">
               Confirmo que los datos que proporciono son veraces y corresponden a mi persona, los cuales servirán para
               emitir los comprobantes fiscales (CFDI).
            </li>
            <li class="bold">
               Acepto que, si esta información no concuerda con la que cuenta el SAT, RedGirasol emita los comprobantes
               sin efectos fiscales.
            </li>
         </div>
      </vx-card>
   </div>
</template>
  
<script>
import investorInfoHelper from "@/helpers/investorInfoHelper";
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";

export default {
   name: 'InvestorTaxProfile',
   mixins: [investorInfoHelper, dateHelper, formatHelper],
   props: {
      showButton: {
         type: Boolean, required: false, default: true
      },
   },
   data() {
      return {
         satUrl: 'https://www.sat.gob.mx/aplicacion/login/53027/genera-tu-constancia-de-situacion-fiscal.',
         investorId: null,
         investorUserId: null,
         userPersonTypePF: 1,
         userPersonTypePM: 0,
         collections: {
            allTaxRegimes: [],
            allCfdis: [],
            cfdisFiltered: [],
            taxRegimesFiltered: [],
         },
         rfcUrl: "https://www.sat.gob.mx/aplicacion/operacion/31274/consulta-tu-clave-de-rfc-mediante-curp",
         colClass: "vx-col lg:w-1/2 sm:w-full w-full mb-5",
         userPersonType: null,
         rfc: null,
         taxName: '',
         taxZipCode: '',
         cfdiId: null,
         taxRegimeId: null,
         fiscalValidationTimestamp: null,
         requiredRules: "required",
         requiredPlaceholder: "(Requerido)",
         errorMssg: null,
      }
   },
   async mounted() {
      this.showLoading(true);
      try {
         await this.getInvestorInfo();
         await this.getUserTaxProfileData();
      } catch (error) {
         console.log(error);
      }
      this.showLoading(false);
   },
   methods: {
      async getInvestorInfo() {
         this.investorId = this.$route.params.id;
         const requiredObjects = ['user'];
         const investor = await this.getInvestorData(this.investorId, requiredObjects);
         this.investorUserId = investor.user.id;
      },
      async getUserTaxProfileData() {
         try {
            const response = await axios.get(`/api/v1/user/${this.investorUserId}/getTaxProfile`);
            this.userPersonType = response.data.person_type
            this.rfc = response.data.rfc;
            this.taxName = response.data.tax_name;
            this.taxZipCode = response.data.tax_zipcode;
            this.taxRegimeId = response.data.tax_regime_id;
            this.fiscalValidationTimestamp = response.data.fiscal_validation_timestamp;
            await this.getCollections();
            this.setCfdis();
            this.cfdiId = response.data.cfdi_id;
         }
         catch (e) {
            this.error_message = 'Ocurrió  un error al obtener los datos, inténtalo mas tarde.'
         }
      },
      async getCollections() {
         try {
            let collectionsObjects = ["cfdis", "taxRegimes"];
            let params = "with[]=" + collectionsObjects.join("&with[]=");
            let res = await this.publicApiGet(
               `/api/v1/forms/getPublicFormCollections?${params}`
            );
            let colls = res.data;
            this.collections.allCfdis = colls.cfdis;
            this.collections.allTaxRegimes = colls.taxRegimes;
            let taxRegimesForPersonType = null;
            if (this.userPersonType == this.userPersonTypePF) {
               taxRegimesForPersonType = colls.taxRegimes.filter(
                  (taxRegime) => taxRegime.for_person
               );
            } else if (this.userPersonType == this.userPersonTypePM) {
               taxRegimesForPersonType = colls.taxRegimes.filter(
                  (taxRegime) => taxRegime.for_business
               );
            }
            taxRegimesForPersonType.forEach((opt) => {
               this.collections.taxRegimesFiltered.push({
                  value: opt.id,
                  label: opt.sat_code + "-" + opt.description,
               }); //conversion a sintaxis de vx-select
            });
         } catch (e) { }
      },
      async saveDataForm() {
         this.errorMssg = null;
         if (!(await this.validateForm())) {
            return;
         }
         let validRfc = this.isValidRfcFormat(this.rfc);
         if (!validRfc) {
            this.errorMssg = "La estructura de la clave RFC es incorrecta."
            setTimeout(() => this.errorMssg = null, 5000);
            return;
         }
         this.showLoading(true, "Guardando información...");
         try {
            let payload = {
               rfc: this.rfc,
               cfdi_id: this.cfdiId,
               tax_regime_id: this.taxRegimeId,
               tax_zipcode: this.taxZipCode,
               tax_name: this.taxName,
               capital_regime_id: this.capitalRegimeId
            };
            await axios.post(`/api/v1/user/${this.investorUserId}/saveTaxProfile`, payload);
            this.showLoading(false);
            this.$emit('on-form-saved', 1)
            if (this.showButton) {
               this.saveSuccessNotif();
            } else {
               this.saveSuccessNotif("Perfil fiscal verificado.", "Si deseas actualizarlos nuevamente contactanos por el chat.");
            }
            await this.getUserTaxProfileData();
            if (!this.showButton) {
               return true;
            }
         } catch (e) {
            if (e?.response?.data?.error) {
               this.showLoading(false);
               this.errorNotifDialog('Aviso', e.response.data.error);
            }
            else {
               this.showLoading(false);
               this.errorNotifDialog('Aviso', 'No ha sido posible obtener la información, intente más tarde.');
            }
         }
      },
      async validateForm() {
         this.errorMssg = null;
         let complete = false;
         if (this.$validator.validateAll()) {
            if (this.cfdiId != null && this.taxRegimeId != null && this.rfc != null && this.taxZipCode != null && this.taxName != null
               && this.rfc != '' && this.taxZipCode != '' && this.taxName != '') {
               complete = true;
            } else {
               this.errorMssg = "Debes completar todos los campos";
               setTimeout(() => this.errorMssg = null, 5000);
            }
         }
         return complete;
      },
      setCfdis() {
         this.cfdiId = null;
         let result = this.collections.allTaxRegimes.find(taxRegime => taxRegime.id === this.taxRegimeId);
         let taxRegimeSatCode = result ? result.sat_code : null;
         if (!taxRegimeSatCode) {
            return;
         }
         this.collections.cfdisFiltered = [];
         this.collections.allCfdis.forEach((cfdi) => {
            if (cfdi.recipient_tax_regime.includes(taxRegimeSatCode)) {
               this.collections.cfdisFiltered.push({
                  value: cfdi.id,
                  label: cfdi.sat_code + "-" + cfdi.description,
               }); //conversion a sintaxis de vx-select             
            }
         });
      },
      hasError(val) {
         return this.errors.has(val);
      },
      errorText(val) {
         return this.errors.first(val);
      },
      isSuccess(val) {
         let ff = this.fields[val];
         return ff && ff.required && ff.valid;
      },
   }
}
</script>
  